import Vue from 'vue';
import * as MUTATIONS from '@/store/constants/mutations.js';
import { mapSetter } from 'commons/vuex/map/map.js';
import { getSearch } from './state.js';
import { clobber } from 'commons/vuex/map/map.js';

export const mutations = {
    [MUTATIONS.SET_SEARCH]: mapSetter(Vue, getSearch),

    [MUTATIONS.ADD_CONTENT_TO_SEARCH](state, { saved_search_uuid, content_id }) {
        const search = state[saved_search_uuid];

        if (!search.content) {
            search.content = [];
        }

        if (search.content.includes(content_id)) {
            return;
        }

        search.content.push(content_id);
    },

    [MUTATIONS.REMOVE_CONTENT_FROM_SEARCH](state, { content_id, saved_search_uuid }) {
        const search = state[saved_search_uuid];
        search.content = search.content.filter((content) => content !== content_id);
    },

    [MUTATIONS.SET_SEARCH_PROPERTY](state, { key, item }) {
        clobber(state[key], item);
    },

    [MUTATIONS.REMOVE_SEARCH](state, saved_search_uuid) {
        Vue.delete(state, saved_search_uuid);
    },

    [MUTATIONS.PUSH_PREVIOUS_PAGE](state, { saved_search_uuid, current_page, next_page }) {
        if (!state[saved_search_uuid].previous_pages[next_page]) {
            Vue.set(state[saved_search_uuid].previous_pages, next_page, current_page);
        }
    },

    [MUTATIONS.CLEAR_PREVIOUS_PAGES](state, { saved_search_uuid }) {
        if (state[saved_search_uuid]) {
            Vue.set(state[saved_search_uuid], 'previous_pages', {});
        }
    },
};
